
export default function ServiceAreas() {
  const cities = [
    'Rome', 'Dalton', 'Calhoun', 'Cartersville', 'Summerville',
    'LaFayette', 'Ringgold', 'Chatsworth', 'Cedartown', 'Rockmart',
    'Trenton', 'Fort Oglethorpe', 'Adairsville', 'Resaca', 'Armuchee'
  ];

  const benefits = [
    {
      icon: 'ri-map-pin-user-line',
      title: 'Local Expertise',
      description: 'We understand the unique challenges and opportunities of Northwest Georgia businesses.'
    },
    {
      icon: 'ri-presentation-line',
      title: 'Virtual & On-Site Training',
      description: 'We serve you virtually or we come to your location for hands-on workshops and personalized training sessions.'
    },
    {
      icon: 'ri-phone-line',
      title: 'Regional Support',
      description: 'Quick response times and local support for all your AI implementation needs.'
    }
  ];

  return (
    <section id="service-areas" className="py-24 bg-[#f8f8f9]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-navy/10 rounded-md">
            <span className="text-navy text-base font-semibold">Service Area</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-navy">
            Serving <span className="text-gold">Northwest Georgia</span>
          </h2>
          <p className="text-lg text-charcoal max-w-3xl mx-auto">
            Based in Northwest Georgia, serving local communities with practical AI training and support.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          <div className="bg-white p-6 rounded-xl border border-soft-gray/30 shadow-sm hover:shadow-lg transition-all">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-navy/10 rounded-lg flex-shrink-0">
                <i className="ri-map-pin-fill text-xl text-navy"></i>
              </div>
              <h3 className="text-lg font-bold text-navy">Calhoun</h3>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl border border-soft-gray/30 shadow-sm hover:shadow-lg transition-all">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-navy/10 rounded-lg flex-shrink-0">
                <i className="ri-map-pin-fill text-xl text-navy"></i>
              </div>
              <h3 className="text-lg font-bold text-navy">Dalton</h3>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl border border-soft-gray/30 shadow-sm hover:shadow-lg transition-all">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-navy/10 rounded-lg flex-shrink-0">
                <i className="ri-map-pin-fill text-xl text-navy"></i>
              </div>
              <h3 className="text-lg font-bold text-navy">Rome</h3>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl border border-soft-gray/30 shadow-sm hover:shadow-lg transition-all">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-navy/10 rounded-lg flex-shrink-0">
                <i className="ri-map-pin-fill text-xl text-navy"></i>
              </div>
              <h3 className="text-lg font-bold text-navy">Cartersville</h3>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl border border-soft-gray/30 shadow-sm hover:shadow-lg transition-all">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-navy/10 rounded-lg flex-shrink-0">
                <i className="ri-map-pin-fill text-xl text-navy"></i>
              </div>
              <h3 className="text-lg font-bold text-navy">Jasper</h3>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl border border-soft-gray/30 shadow-sm hover:shadow-lg transition-all">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-navy/10 rounded-lg flex-shrink-0">
                <i className="ri-map-pin-fill text-xl text-navy"></i>
              </div>
              <h3 className="text-lg font-bold text-navy">Ellijay</h3>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl border border-soft-gray/30 shadow-sm hover:shadow-lg transition-all">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-navy/10 rounded-lg flex-shrink-0">
                <i className="ri-map-pin-fill text-xl text-navy"></i>
              </div>
              <h3 className="text-lg font-bold text-navy">Ringgold</h3>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl border border-soft-gray/30 shadow-sm hover:shadow-lg transition-all">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-navy/10 rounded-lg flex-shrink-0">
                <i className="ri-map-pin-fill text-xl text-navy"></i>
              </div>
              <h3 className="text-lg font-bold text-navy">Kennesaw</h3>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl border border-soft-gray/30 shadow-sm hover:shadow-lg transition-all">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-navy/10 rounded-lg flex-shrink-0">
                <i className="ri-map-pin-fill text-xl text-navy"></i>
              </div>
              <h3 className="text-lg font-bold text-navy">Surrounding Communities</h3>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-navy/5 to-gold/5 p-8 rounded-2xl border border-navy/10 text-center">
          <p className="text-charcoal text-lg">
            <strong className="text-navy">Limited availability</strong> in Chattanooga and North Atlanta suburbs.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl border border-soft-gray/30 text-center hover:border-gold/50 transition-all shadow-sm"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-navy/10 rounded-full mx-auto mb-6">
                <i className={`${benefit.icon} text-3xl text-navy`}></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-navy">{benefit.title}</h3>
              <p className="text-charcoal leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-navy to-[#062299] p-8 rounded-2xl shadow-2xl max-w-3xl">
            <h3 className="text-2xl font-bold mb-4 text-white">Ready to Get Started?</h3>
            <p className="text-white/90 mb-6">
              Schedule a free consultation to discuss how AI can transform your business.
            </p>
            <a
              href="https://calendly.com/evernorthai/discovery"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-3 bg-gold text-white font-semibold rounded-full hover:bg-[#a68a4e] transition-all cursor-pointer whitespace-nowrap"
            >
              Book Free Consultation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
